import React from 'react'
import { COLORES } from '../../../../config/colores'
import DirectionsBoatIcon from '@material-ui/icons/DirectionsBoat'
import { connect } from 'react-redux'
import { updateFechaCalendario } from '../../actions/listados'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  toneladas: {
    '&:hover': {
      fontWeight: 'bold'
    }
  }
}))

function EstimacionCargaBuque (props) {
  const { carga, updateFechaCalendario } = props

  const classes = useStyles()

  const handleButtonClick = () => {
    updateFechaCalendario(props.fechaDeCarga)
  }

  return (
    <div
      style={{ display: 'flex', cursor: 'pointer' }}
      className='animation-zoomInUp'
      onClick={handleButtonClick}
    >
      { carga > 0 &&
        <>
          <DirectionsBoatIcon
            fontSize='small'
            style={{ color: COLORES.grey.dark }}
          />
          <span className={!props.isSimulacionExportador ? classes.toneladas : ''}>{(carga).toLocaleString()} tn.</span>
        </>
      }
    </div>
  )
}

const mapStateToProps = (state) => ({
  isSimulacionExportador: state.stock.isSimulacionExportador
})
const mapActionsToProps = {
  updateFechaCalendario
}
const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(EstimacionCargaBuque)
